/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    country: string | null;
}

/**
 * Check if a given object implements the AddressDto interface.
 */
export function instanceOfAddressDto(value: object): value is AddressDto {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function AddressDtoFromJSON(json: any): AddressDto {
    return AddressDtoFromJSONTyped(json, false);
}

export function AddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
    };
}

export function AddressDtoToJSON(json: any): AddressDto {
    return AddressDtoToJSONTyped(json, false);
}

export function AddressDtoToJSONTyped(value?: AddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

